<template>
  <!-- CONSENT DIALOG -->
  <v-dialog
      v-model="showConsentDialog"
      fullscreen
      scrollable
  >
    <v-card
        class="rounded-lg d-flex flex-column"
    >
      <v-btn
          class="mt-3"
          color="primary"
          fab
          depressed
          dark
          small
          absolute
          right
          @click.prevent="showConsentDialog = false"
      >
        <v-icon small>fal fa-close</v-icon>
      </v-btn>
      <v-card-title class="text-break"><strong>{{ $t('cards.titles.consent') }}</strong></v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-3">
        <div v-if="!consentLoading" v-html="consentPage"></div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end mt-auto">
        <!--<v-btn
                @click.prevent="handleConsent(false)"
                class="mr-1 rounded-lg"
                depressed
                outlined
                color="error"
                :disabled="!consent.approved"
        >
            {{ $t('buttons.deny')}}
        </v-btn>-->
        <v-btn
            @click.prevent="handleConsent(true)"
            class="rounded-lg"
            depressed
            color="primary"
            :disabled="consent.approved"
            :loading="handleConsentLoading"
        >
          {{ $t('buttons.accept')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-consent-dialog",
  data() {
    return {
      isLoading: false,
      consentPage: '',
      consentPageInstanceId: null,
      consentLoading: false,
      showConsentDialog: false,
      acceptConsent: false,
      consent: {},
      handleConsentLoading: false,
      consentDialogIdentifier: '',
      consentLabel: ''
    }
  },

  mounted(){
    this.$root.$on('open-consent-dialog', (data) => {
      this.fetchConsentMarkdown(data)
    })
  },

  methods: {
    fetchConsentMarkdown(data) {
      this.consentLoading = true
      this.consentDialogIdentifier = data.consentDialogIdentifier
      this.consentLabel = data.consentLabel
      const that = this
      api.consent.getPageForLabel(data.consentLabel, that.$i18n.locale)
          .then((res) => {
            that.consentPage = res.data.pageMarkdown
            that.consentPageInstanceId = res.data.instanceId
            that.showConsentDialog = true
            that.consentLoading = false
          })
    },

    async handleConsent(approved){
      this.handleConsentLoading = true
      let that = this
      let data = {
        approved: approved,
        pageInstanceId: that.consentPageInstanceId
      }

      await api.consent.handleConsentForLabel(this.consentLabel, data)
      this.$root.$emit('handle-consent-dialog', { consentDialogIdentifier: this.consentDialogIdentifier, consentData: data })
      // await this.registerForChallenge()
      this.showConsentDialog = false
      this.handleConsentLoading = false
    },
  }
}
</script>

<style scoped>

</style>
